var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGemini = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 5.46987C9.89364 5.46987 7.80827 5.05408 5.86325 4.24634L5.09619 6.0934C6.03828 6.48463 7.00963 6.79413 7.99951 7.01976V16.9835C7.01419 17.2069 6.04315 17.5143 5.09717 17.9058L5.86187 19.7538C9.77924 18.1328 14.1798 18.1328 18.0972 19.7538L18.8619 17.9058C17.9287 17.5196 16.9711 17.2153 15.9995 16.9926V7.01985C16.9895 6.79422 17.961 6.48469 18.9032 6.0934L18.1362 4.24634C16.1912 5.05408 14.1058 5.46987 11.9997 5.46987ZM13.9995 7.35844C13.3368 7.43252 12.6692 7.46987 11.9997 7.46987C11.3301 7.46987 10.6624 7.43251 9.99951 7.35839V16.6473C11.3288 16.5002 12.6705 16.5017 13.9995 16.6518V7.35844Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGemini);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gemini.7cd1cb35d609a21446e564ae1430c3ef.svg";